import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import {
  HrWhite,
  HrFlexContainer,
  HrButtons,
  HrParagraph,
  HrCustomButton,
  HrFontBold,
  BumeranColor,
  BumeranColorHover,
  ZonajobsColorHover,
  ZonajobsColor
} from '@components/styles/hr-styles';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import useStore from '../store/useStore';
import { MiniLogoBumeran, MiniLogoZonajobs } from '../../utils/image-svg';
import { DisplaySettingsContext } from '../store/display-settings';

const Flex = styled(HrFlexContainer)`
  flex-wrap: nowrap;
  justify-content: center;

  @media (max-width: 550px) {
    flex-wrap: wrap;
  }
`;
const CustomButton = styled(HrCustomButton)`
  max-width: 300px;
  font-size: ${(props) => `${16 + (props.fontSizeSetting || 0)}px !important`};

  @media (max-width: 550px) {
    max-width: none;
  }
`;
const CustomButton2 = styled(HrButtons)`
  background-color: ${(props) => props.backgroundColor || ''};
  max-width: 316px;
  width: 100%;
  font-size: ${(props) => `${16 + (props.fontSizeSetting || 0)}px !important`};

  @media (max-width: 550px) {
    max-width: none;
  }
`;

export const StepImportCv = observer(({ showModalLogin, setShowModalLogin, show }) => {
  const [t] = useTranslation();
  const { getDataPostulant } = useStore();
  const showBumeranButton = getDataPostulant.postulationOptions?.bumeran.allowPostulation;
  const showZonajobsButton = getDataPostulant.postulationOptions?.zonaJobs.allowPostulation;
  const nameBumeranButton = getDataPostulant.postulationOptions?.bumeran.name || t('general.hiringroom.bumeran');
  const nameZonajobsButton = getDataPostulant.postulationOptions?.zonaJobs.name || t('general.hiringroom.zonajobs');
  const urlBumeran = getDataPostulant.postulationOptions?.bumeran.url;
  const urlZonajobs = getDataPostulant.postulationOptions?.zonaJobs.url;
  const navigate = useNavigate();
  const location = useLocation();
  const { darkMode, fontSizeSetting} = useContext(DisplaySettingsContext);

  return (
    <HrFlexContainer flexDirection='column' gap='32px' padding='32px 16px' style={{ display: show ? '' : 'none' }}>
      {(showBumeranButton || showZonajobsButton) && (
        <HrParagraph fontSizeSetting={fontSizeSetting} textAlign='center' fontWeight={HrFontBold}  color={darkMode ? 'white' : ''} >
          {t('postulant.step_one.apply_from')}
        </HrParagraph>
      )}
      <HrFlexContainer flexDirection='column'>
        <Flex>
          {showBumeranButton && (
            <CustomButton
              className='postulation-bumeran'
              type='button'
              padding='0px 32px'
              height='48px'
              backgroundColor={BumeranColor}
              backgroundColorHover={BumeranColorHover}
              backgroundColorActive={BumeranColor}
              fontSizeSetting={fontSizeSetting}
              width='100%'
              color={HrWhite}
              onClick={() => {
                setShowModalLogin({
                  ...showModalLogin,
                  show: getDataPostulant.bumeran === null,
                  portal: 'bumeran',
                  url: urlBumeran,
                  autoLogin: false,
                  apply_with: getDataPostulant.postulationOptions.bumeran.applyWith
                });
              }}
            >
              {MiniLogoBumeran}
              {nameBumeranButton}
            </CustomButton>
          )}
          {showZonajobsButton && (
            <CustomButton
              className='postulation-zonajobs'
              type='button'
              padding='0px 32px'
              height='48px'
              backgroundColor={ZonajobsColor}
              backgroundColorHover={ZonajobsColorHover}
              backgroundColorActive={ZonajobsColor}
              width='100%'
              maxWidth='300px'
              color={HrWhite}
              fontSizeSetting={fontSizeSetting}
              onClick={() => {
                setShowModalLogin({
                  ...showModalLogin,
                  show: getDataPostulant.zonajobs === null,
                  portal: 'zonajobs',
                  url: urlZonajobs,
                  autoLogin: false,
                  apply_with: getDataPostulant.postulationOptions.zonaJobs.applyWith
                });
              }}
            >
              {MiniLogoZonajobs}
              {nameZonajobsButton}
            </CustomButton>
          )}
        </Flex>
        {(showBumeranButton || showZonajobsButton) && <HrParagraph fontSizeSetting={fontSizeSetting} color={darkMode ? 'white' : ''}>ó</HrParagraph>}
        <CustomButton2
          backgroundColor={darkMode ? 'transparent' : ''}
          className='postulation-manual'
          type='button'
          fontSizeSetting={fontSizeSetting}
          category={darkMode ? 'tertiaryGreenDark' : 'tertiaryGreen' }
          size='large'
          onClick={() => {
            navigate({
              pathname: location.pathname,
              replace: true,

              search: location.search,
              state: { currentStep: 2 },
              hash: `#step${2}`
            });
          }}
        >
          {t('postulant.step_one.manually')}
        </CustomButton2>
      </HrFlexContainer>
    </HrFlexContainer>
  );
});
